const DynamicForm = () => {
  const normalizedData = {}

  return normalizedData
}

export default DynamicForm
